
































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useDeclination } from '~/diptyqueTheme/composable';
import type {
  StoryTellingDescriptionPositionTransformed,
  StoryTellingModel
} from '~/diptyqueTheme/types/contentful';
import {
  StoryTellingDescriptionPositionEnum,
  StoryTellingDescriptionPositionTransformedEnum
} from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'StoryTellingContent__mobileDeclination1',
  components: {
    VaimoBanner: () => import('atoms/VaimoBanner.vue'),
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoTruncatedText: () => import('atoms/VaimoTruncatedText.vue')
  },
  props: {
    declinationData: {
      required: true,
      type: Object as PropType<StoryTellingModel>
    }
  },
  setup(props) {
    const { getBannerData: bannerData } = useDeclination(props.declinationData);

    const descriptionPosition =
      computed<StoryTellingDescriptionPositionTransformed>(() => {
        const positionMap = {
          [StoryTellingDescriptionPositionEnum.BEFORE_VISUAL]:
            StoryTellingDescriptionPositionTransformedEnum.BEFORE,
          [StoryTellingDescriptionPositionEnum.AFTER_VISUAL]:
            StoryTellingDescriptionPositionTransformedEnum.AFTER
        };
        return (
          positionMap[props.declinationData.descrPosition] ||
          StoryTellingDescriptionPositionTransformedEnum.BEFORE
        );
      });

    return {
      bannerData,
      descriptionPosition,
      hasPositionBefore: computed(
        () =>
          descriptionPosition.value ===
          StoryTellingDescriptionPositionTransformedEnum.BEFORE
      ),
      hasPositionAfter: computed(
        () =>
          descriptionPosition.value ===
          StoryTellingDescriptionPositionTransformedEnum.AFTER
      )
    };
  }
});
